var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgArrowTopRight = function SvgArrowTopRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 4V11C14 11.2812 13.75 11.5 13.5 11.5C13.2188 11.5 13 11.2812 13 11V5.21875L4.84375 13.375C4.75 13.4688 4.625 13.5 4.5 13.5C4.34375 13.5 4.21875 13.4688 4.125 13.375C3.9375 13.1875 3.9375 12.8438 4.125 12.6562L12.2812 4.5H6.46875C6.21875 4.5 5.96875 4.25 6 4C6 3.71875 6.21875 3.5 6.5 3.5H13.5C13.75 3.5 14 3.75 14 4Z"
  })));
};
export default __webpack_public_path__ + "assets/1e77a66d50e13a387053d7f0ffdb33cd.svg";
export { SvgArrowTopRight as ReactComponent };


// WEBPACK FOOTER //
// ./assets/icons/arrow-top-right.svg